import logo from './logo.svg';
import './App.css';
import TopNav from './Components/TopNav';
import { Container } from '@mui/material';
import Header from './Components/Header/Header';
import Sidebar from './Components/Sidebar/Sidebar';
import About from './Components/About/About';
import Experience from './Components/Experience/Experience';
import Projects from './Components/Projects/Projects';
import Contact from './Components/Contact';
import Reviews  from './Components/Reviews/Reviews';
import ChatbaseWidget from './Components/ChatbaseWidget';
import { useState, useEffect, createContext } from 'react';

export const PortfolioContext = createContext(null);


function App() {
  const [data, setData] = useState([]);

  const getData = () => {
    fetch('data/info.json', {
      headers : { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    .then(function(response){
        return response.json();
    })
    .then(function(myJson) {
      setData(myJson)
    });
  }
  useEffect(()=>{
    getData();
  },[])

  return (
    <PortfolioContext.Provider value={data}>
      <div className="App">
        <ChatbaseWidget />
        <TopNav />
        <Sidebar />
        <Container className='responsive-container'>
          <Header />
          <About />
          <Experience />
          <Projects />
          <Reviews />
          <Contact />
        </Container>
      </div>

    </PortfolioContext.Provider>
  );
}

export default App;
